import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  RadioGroup,
  FormControlLabel,
  Button,
  Checkbox,
} from '@material-ui/core'
import clsx from 'clsx'
import Grid from '@material-ui/core/Grid'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import {
  usePlateSessionFieldMutation,
  useDuplexSpecificationValidationMutation,
  usePlateTotalValidationMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetPlatePriceCallLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import { Specifications, ActiveLinkTypeDnaplate } from '../enum'
import { dnaPlatesRoute, useRouter } from '@src/routes'
import { configContext } from '../DnaPlates'
import CircleLoader from '@src/components/CircleLoader'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import { dropAllKeyInstances } from '@src/utils/ObjectHelpers/dropKeys'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 7, 6),
    },
    dFlexDirectionRowReverse: {
      flexDirection: 'row-reverse',
    },
    dFlex: {
      display: 'flex',
    },
    root: {
      flexGrow: 1,
    },
    plateType: {
      marginTop: theme.spacing(7),
      marginLeft: theme.spacing(2),
    },
    font: {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(2),
    },
    radio: {
      padding: theme.spacing(1),
    },
    labelFont: {
      paddingLeft: theme.spacing(4),
      '& .MuiTypography-body1': {
        fontSize: theme.spacing(3.5),
      },
    },
    specificationsHeading: {
      paddingLeft: theme.spacing(1.6),
    },
    confirmButton: {
      color: theme.palette.common.white,
      width: theme.spacing(50),
    },
    buttonMargin: {
      marginTop: theme.spacing(5),
    },
    formatText: {
      margin: theme.spacing(1, 0, 0, 2),
    },
    colorRed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(13),
    },
    hideRow: {
      display: 'none',
    },
    errormsg: {
      marginLeft: theme.spacing(2),
    },
    over1: {
      fontSize: theme.typography.pxToRem(14),
      color: '#1d5293',
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: theme.spacing(2),
    },
    overrideCheckBox: {
      padding: theme.spacing(0),
    },
    marginRoot: {
      marginRight: theme.spacing(0),
    },
    disableText: {
      color: theme.palette.text.disabled,
    },
    specificationsHelpText: {
      fontSize: theme.typography.pxToRem(12),
    },
  }
})

const DuplexPlateSpecifications = (props) => {
  const classes = useStyles()
  const { specificationsData, productDetails } = props
  const intl = useIntl()
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, isPageLoad } = state
  const [platesessionField] = usePlateSessionFieldMutation()
  const [duplexSpecificationValidation, { loading: specificationLoading }] =
    useDuplexSpecificationValidationMutation()
  const [plateTotalValidation, { loading: totalvalidationaloading }] =
    usePlateTotalValidationMutation()
  const router = useRouter()

  const [purification, setPurification] = React.useState(
    sessionData[0].purification
  )
  const [amount, setAmount] = React.useState(sessionData[0].amount)
  const [stateToSave, setStateToSave] = React.useState(false)
  const [reqpurification, setReqpurification] = React.useState(false)
  const [reqAmount, setReqAmount] = React.useState(false)
  const [isOverriden, setIsOverriden] = React.useState(
    sessionData[0].isSpecificationsOverridden
  )

  const [getPriceData, { data, loading: priceLoading }] =
    useGetPlatePriceCallLazyQuery()

  const fetchPriceData = async (obj) => {
    await getPriceData({
      variables: { product: obj },
    })
  }

  React.useEffect(() => {
    if (
      data !== undefined &&
      !data.getPlatePriceCall?.serverError &&
      data.getPlatePriceCall?.response !== null
    ) {
      dispatch({
        type: 'UPDATE_PLATE_PRICE',
        data: data.getPlatePriceCall?.response,
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  React.useEffect(() => {
    if (isPageLoad) {
      setPurification(sessionData[0].purification)
      setAmount(sessionData[0].amount)
      setIsOverriden(sessionData[0].isSpecificationsOverridden)
      setStateToSave(true)
      if (
        sessionData[0].biTubeWellList[0].pageNo === 3 &&
        (sessionData[0].biTubeWellList[0].amount === '' ||
          sessionData[0].biTubeWellList[0].amount === null ||
          sessionData[0].biTubeWellList[0].amount === undefined) &&
        isOverriden !== true
      ) {
        setReqAmount(true)
      }
      if (
        sessionData[0].biTubeWellList[0].pageNo === 3 &&
        (sessionData[0].biTubeWellList[0].purification === '' ||
          sessionData[0].biTubeWellList[0].purification === null ||
          sessionData[0].biTubeWellList[0].purification === undefined) &&
        isOverriden !== true
      ) {
        setReqpurification(true)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [isPageLoad])

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }

  const validationSpecifications = async (obj) => {
    const response = await duplexSpecificationValidation({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (
      data?.duplexSpecificationValidation?.response &&
      !data?.duplexSpecificationValidation?.serverError
    ) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_WELLSPECIFICATION_VALIDATION',
        data: data.duplexSpecificationValidation.response,
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }

  React.useEffect(() => {
    if (
      !(
        state.wellSpecifications.length === 1 &&
        state.wellSpecifications[0].id === 0
      )
    ) {
      let intersectionOfAmount = state.wellSpecifications[0]?.listAmount
      let intersectionOfPurification =
        state.wellSpecifications[0]?.listPurification
      const getArraysIntersection = (a1, a2) => {
        return a1?.filter(function (n) {
          return a2?.indexOf(n) !== -1
        })
      }
      state.wellSpecifications.forEach((well) => {
        intersectionOfAmount = getArraysIntersection(
          intersectionOfAmount,
          well.listAmount
        )
        intersectionOfPurification = getArraysIntersection(
          intersectionOfPurification,
          well.listPurification
        )
      })
      dispatch({
        type: 'UPDATE_INTERSECTION_VALUES',
        data: {
          ...state.intersectionValues,
          listPurification: intersectionOfPurification,
          listAmount: intersectionOfAmount,
        },
      })

      if (sessionData[0].isSpecificationsOverridden !== true) {
        if (intersectionOfPurification.length === 1) {
          sessionData.forEach((session) => {
            session.purification = intersectionOfPurification[0]
            session.biTubeWellList.forEach((well) => {
              well.purification = intersectionOfPurification[0]
            })
          })
          setReqpurification(false)
          setPurification(intersectionOfPurification[0])
        }
        if (intersectionOfAmount.length === 1) {
          sessionData.forEach((session) => {
            session.amount = intersectionOfAmount[0]
            session.biTubeWellList.forEach((well) => {
              well.amount = intersectionOfAmount[0]
            })
          })
          setReqAmount(false)
          setAmount(intersectionOfAmount[0])
        }
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      savePlateDataToSession(sessionData)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.wellSpecifications])

  const disablingRadioButton = (data, categoryName) => {
    if (Object.keys(state.intersectionValues).length !== 0) {
      let list: any = []

      switch (categoryName) {
        case messages.CONF_AMOUNT_TEXT.defaultMessage: {
          list = state.intersectionValues.listAmount

          break
        }
        case messages.CONF_PURIFICATION_TEXT.defaultMessage: {
          if (
            sessionData[0].biTubeWellList[0].amount !== '' &&
            sessionData[0].biTubeWellList[0].amount
          ) {
            list = state.intersectionValues.listPurification
          }

          break
        }
        default:
          return false
      }
      if (list === null) {
        return true
      } else if (list.includes(data.value)) {
        return false
      }
    }
    return true
  }

  React.useEffect(() => {
    if (stateToSave) {
      sessionData.forEach((data) => {
        data.format = Specifications.DRY
        data.purification = purification
        data.amount = amount
        data.shipping = Specifications.Ambient
        data.packageType = Specifications.PLATE_96_DEEP_800
        data.isSpecificationsOverridden = isOverriden
        data.biTubeWellList.forEach((well) => {
          well.format = Specifications.DRY
          well.purification = purification
          well.amount = amount
          well.shipping = Specifications.Ambient
          well.packageType = Specifications.PLATE_96_DEEP_800
          well.listError = []
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      validationSpecifications(sessionData[0].biTubeWellList)
      setStateToSave(false)
    }

    // TODO: need a test before we refactor these dependencies
  }, [stateToSave])

  const checkRequiredFields = (error) => {
    error.forEach((obj) => {
      if (obj.key === Specifications.purification) {
        setReqpurification(true)
      }
      if (obj.key === Specifications.amount) {
        setReqAmount(true)
      }
    })
  }

  const totalValidation = async () => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    let errorCount = 0
    if (data && !data.plateTotalValidation.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: data.plateTotalValidation.response,
      })
      data.plateTotalValidation.response.forEach((plate) => {
        plate.biTubeWellList.forEach((duplexwell) => {
          if (duplexwell.listError.length !== 0) {
            errorCount = errorCount + 1
          }
        })
      })
      if (errorCount !== 0) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        checkRequiredFields(
          data.plateTotalValidation.response[0].biTubeWellList[0].listError
        )
        window.scrollTo(0, 0)
        sessionData.forEach((data) => {
          data.pageNo = 2
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        dispatch({ type: 'SET_STEP_NO', data: 2 })
      } else {
        dispatch({ type: 'SET_STEP_NO', data: 3 })
        const url = `${dnaPlatesRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkTypeDnaplate.OrderConfirmation}`
        router.push(url)
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    savePlateDataToSession(sessionData)
  }
  const goToNextStep3 = () => {
    sessionData.forEach((data) => {
      // Drop __typename from the data object and then bind that return to the data on the loop.
      const dataRecast = dropAllKeyInstances(data, ['__typename'])
      data = dataRecast

      data.pageNo = 3
      data.biTubeWellList.forEach((duplexwell) => {
        if (data.isSpecificationsOverridden !== true) {
          duplexwell.pageNo = 3
        } else {
          duplexwell.pageNo = 0
        }
      })
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    totalValidation()
    fetchPriceData(productDetails)
  }

  const handleOverride = (value) => {
    sessionData.forEach((data) => {
      data.pageNo = 2
    })
    dispatch({ type: 'SET_STEP_NO', data: 2 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setReqpurification(false)
    setReqAmount(false)
    setIsOverriden(value)
    setStateToSave(true)
  }

  const handlerChange = (e, type) => {
    sessionData.forEach((data) => {
      data.pageNo = 2
    })
    dispatch({ type: 'SET_STEP_NO', data: 2 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    if (type === Specifications.purification) {
      setPurification(e.target.value)
      setReqpurification(false)
      setStateToSave(true)
    } else if (type === Specifications.amount) {
      setAmount(e.target.value)
      setReqAmount(false)
      setStateToSave(true)
    }
  }

  const specificationData = (specificationsData, specificationType) => {
    return specificationsData.specificationModifications.map(
      (specification, index) => {
        return (
          <FormControlLabel
            key={index}
            value={specification.value}
            control={
              <StyledRadio
                isConfiguratorsRedesign="true"
                className={classes.radio}
                onChange={(e) => handlerChange(e, specificationType)}
              />
            }
            className={clsx(classes.labelFont)}
            label={intl.formatMessage(
              checkValidKey(
                messages[specification.displayName],
                specification.displayName
              )
            )}
            disabled={
              isOverriden === true
                ? false
                : disablingRadioButton(specification, specificationType)
            }
          />
        )
      }
    )
  }

  const populateSpecification = (specificationsData, specificationType) => {
    return specificationsData.specifications.map((specificationList, index) => {
      if (specificationList.categoryName === specificationType) {
        return (
          <RadioGroup
            aria-label="radio"
            name="radio"
            key={index}
            value={sessionData[0][specificationType]}
          >
            {specificationData(specificationList, specificationType)}
          </RadioGroup>
        )
      }
      return null
    })
  }
  return (
    <>
      <div
        className={clsx(
          classes.contentWrapper,
          classes.dFlexDirectionRowReverse
        )}
      >
        <Grid container>
          <Grid item xs={9} className={classes.specificationsHeading}>
            <h2>
              <FormattedMessage {...messages.CONF_PEPSCREEN_SPECIFICATION} />
            </h2>
          </Grid>
          <Grid item xs={3}>
            {productDetails.isCSRSupervisor === true ? (
              <FormControlLabel
                classes={{ label: classes.over1, root: classes.marginRoot }}
                control={
                  <Checkbox
                    value={isOverriden}
                    color="primary"
                    checked={isOverriden}
                    onChange={() => {
                      handleOverride(!isOverriden)
                    }}
                    className={classes.overrideCheckBox}
                  />
                }
                label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
              />
            ) : (
              ''
            )}
          </Grid>
        </Grid>
        <Grid
          className={clsx(
            classes.specificationsHeading,
            classes.specificationsHelpText
          )}
        >
          <FormattedMessage
            {...messages.CONF_DUPLEXPLATE_SPECIFICATIONS_HELP_TEXT}
          />
        </Grid>
        <Grid>
          <Grid className={classes.plateType}>
            <strong>
              <FormattedMessage {...messages.CONF_PEPSCREEN_AMOUNT} />
            </strong>
          </Grid>
          <div>
            {populateSpecification(specificationsData, Specifications.amount)}
          </div>
          <Grid className={reqAmount ? '' : classes.hideRow}>
            <div className={clsx(classes.colorRed, classes.errormsg)}>
              <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
            </div>
          </Grid>
        </Grid>

        <Grid>
          <Grid container>
            <Grid item className={classes.plateType}>
              <strong>
                <FormattedMessage {...messages.CONF_PEPSCREEN_FORMAT} />
              </strong>
            </Grid>
          </Grid>
          <div className={classes.formatText}>
            <FormattedMessage {...messages.PC_SPEC_DRY_duplexplate} />
          </div>
        </Grid>

        <Grid>
          <Grid container>
            <Grid
              item
              xs={12}
              className={clsx(
                classes.plateType,
                sessionData[0].amount && sessionData[0].amount !== ''
                  ? ''
                  : classes.disableText
              )}
            >
              <strong>
                <FormattedMessage {...messages.CONF_PURIFICATION} />
              </strong>
            </Grid>
          </Grid>
          <div>
            {populateSpecification(
              specificationsData,
              Specifications.purification
            )}
          </div>
          <Grid className={reqpurification ? '' : classes.hideRow}>
            <div className={clsx(classes.colorRed, classes.errormsg)}>
              <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
            </div>
          </Grid>
        </Grid>
      </div>
      <Grid>
        <div className={classes.buttonMargin}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            className={classes.confirmButton}
            onClick={goToNextStep3}
          >
            <FormattedMessage {...messages.CONF_CONTINUE_DNA_PLATES} />
          </Button>
        </div>
      </Grid>
      {(specificationLoading || totalvalidationaloading || priceLoading) && (
        <CircleLoader />
      )}
    </>
  )
}
export default DuplexPlateSpecifications
